import { observer } from 'mobx-react-lite';
import React from 'react';
import '../../../../styles/components/calendar/dayCalendar.scss';
import { CurrentTimeLine } from '../../../currentTimeLine';
import { Cols } from '../../components';
import { Header } from './Header';

export const DayCalendar = observer(() => {

  return (
    <div className="calendar day-calendar">
      <CurrentTimeLine />
      <Header />
      <Cols isDayCalendar />
    </div>
  );
});
